;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import * as Sentry from "@sentry/nextjs";
import { SENTRY_APPLICATION_KEY } from "@/lib/observability/application-key";
import { SENTRY_REPLAY_OPTIONS } from "@/lib/observability/scrub";

/**
 * Browser init only: the Edge build rejects these SDK exports, so nothing the
 * server or Edge init imports may reference them.
 *
 * `applicationKey` in `next.config.ts` marks bundled app frames, so stacks made
 * only of vendor scripts (Chatbase `embed.min.js`, Smartlook) never become Issues.
 */
export function buildBrowserIntegrations({
	replayEnabled,
}: {
	replayEnabled: boolean;
}) {
	return [
		Sentry.thirdPartyErrorFilterIntegration({
			behaviour: "drop-error-if-exclusively-contains-third-party-frames",
			filterKeys: [SENTRY_APPLICATION_KEY],
		}),
		...(replayEnabled ? [Sentry.replayIntegration(SENTRY_REPLAY_OPTIONS)] : []),
	];
}
